import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@scan-vin/environments/environment';
import * as Sentry from '@sentry/angular';
import { sentryConfig } from '@shared/consts/sentry-init-config';
import { environmentConfigFactory } from '@shared/factories/environment-config.factory';

if (environment.production) {
  const dsn = environmentConfigFactory(environment).sentry.dsn;
  Sentry.init({ dsn, ...sentryConfig });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
